import './theme.js';
import onDocumentLoaded from './onDocumentLoaded';

/* import {Analytics} from "@plaudit/analytics";
Analytics.setup(); */

function setupFreeShippingBar() {
    var checkoutButton = document.getElementById("free-shipping-bar-checkout-btn");
    if (checkoutButton !== null) {
        checkoutButton.addEventListener("click", () => {
            if ((window as any).Rebuy !== undefined && (window as any).Rebuy.SmartCart !== undefined) {
                (window as any).Rebuy.SmartCart.checkout();
            }
        });
    }
}

onDocumentLoaded(document, setupFreeShippingBar);

document.addEventListener('rebuy:smartcart.hide', function (event: UIEvent) {

    var currentFreeShippingBar = document.querySelector('.free-shipping-bar');

    currentFreeShippingBar.classList.add('free-shipping-bar--updating');

    fetch(window.location.href).then(function (response) {
        // The API call was successful!
        return response.text();
    }).then(function (html) {

        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var parsedDoc = parser.parseFromString(html, 'text/html');

        // Get the image file
        var cartCount = parsedDoc.getElementById('CartCount');
        var currentCartCount = document.getElementById('CartCount');
        var freeShippingBar = parsedDoc.querySelector('.free-shipping-bar');

        currentFreeShippingBar.replaceWith(freeShippingBar);
        currentCartCount.replaceWith(cartCount);

        setupFreeShippingBar();

        currentFreeShippingBar.classList.remove('free-shipping-bar--updating');
    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });

});